import { Fragment, useEffect, useState } from "react";
import { useMediaQuery } from "@mui/material";
import { CustomTextField } from "../TracksPageComponents/styles";
import { ProjectFileSearchBarProps } from "./types";
import CustomButton from "../CustomButton/CustomButton";

export const ProjectFileSearchBar: React.FC<ProjectFileSearchBarProps> = ({
  queryValue,
  setQueryValue,
}) => {
  const [query, setQuery] = useState<string>("");
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const escapeRegex = (input: string) => {
    return input.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  const handleQueryChange = (e: string) => {
    setQuery(e);
    if (e === "") {
      setQueryValue("");
    }
  };

  useEffect(() => {
    if (queryValue === "") {
      setQuery("");
    }
  }, [queryValue]);

  const handleEnterPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" && query.trim() !== "") {
      setQueryValue(escapeRegex(query.trim()));
    }
  };

  return (
    <>
      <CustomTextField
        sx={{
          width: isSmallScreen ? "90vw" : "300px",
        }}
        value={query}
        placeholder="Search files"
        onKeyPress={handleEnterPress}
        size={isSmallScreen ? "small" : "medium"}
        onChange={(e) => {
          handleQueryChange(e.target.value);
        }}
        InputProps={{
          endAdornment: (
            <Fragment>
              <CustomButton
                text="Search"
                onClick={() => {
                  if (query.trim() !== "") {
                    setQueryValue(escapeRegex(query));
                  }
                }}
              />
            </Fragment>
          ),
        }}
      />
    </>
  );
};
